<template>
  <div>
    <v-layout wrap class="mb-4">
      <v-flex xs9>
        <img src="/static/img/logo_shippop.png" style="max-height: 50px" />
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn fab outline small color="primary" v-if="!isEdit" @click="editShippop">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <div>
      {{
        $t(
          'Shippop, one stop courier services helping merchants to deliver products more convenient. Support comparing shipping cost easily, including support online payment via credit and debit cards. Yet also can provide parcel number and parcel cover sheet as well as tracking parcel status through the system immediately. These allow you to control costs and transportation plans so simply effortless.'
        )
      }}
    </div>
    <div v-if="loading" class="spinner text-xs-center">
      <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
    </div>

    <div v-else>
      <v-stepper v-model="step" vertical class="elevation-0">
        <v-stepper-step step="1" :complete="step > 1">
          {{ $t('Register Shippop') }}
        </v-stepper-step>
        <v-stepper-content step="1">
          <div>{{ $t('Connect to Shippop for free with more convenient shipping.') }}</div>
          <v-btn
            depressed
            color="primary"
            :href="'https://www1.shippop.com/embed/register/zwiz/'"
            target="_blank"
            @click="step = 2"
            >{{ $t('Register Shippop') }}</v-btn
          >
          <v-btn flat @click="step = 2">
            {{$t('already_have_an_account')}}
          </v-btn>
          <div>
            <a
              href="https://tinyurl.com/taynws5p"
              target="_blank"
              >{{ $t('How to use SHIPPOP') }}</a
            >
          </div>
        </v-stepper-content>
        <v-stepper-step step="2" :complete="step > 2">
          {{ $t('Connect SHIPPOP to Zwiz') }}
        </v-stepper-step>
        <v-stepper-content step="2">
          <div class="mb-2" v-if="showCancel">
            <div>
              {{ $t('Enable/Disable Shippop') }}
            </div>
            <div>
              <toggle-button
                class="mt-2"
                :value="shippop_status"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="toggleStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
                style="display: inline-block"
              />
            </div>
          </div>

          <template v-if="!showCancel">{{
            $t(
              `After receiving confirmation from Shippop, the Token can be taken. Let's enter to make a connection here.`
            )
          }}</template>
          <div class="caption">Shippop Token</div>
          <div class="form-control" :class="{ 'has-error': errors.has('shippop_jsonvalue_token') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="shippop_jsonvalue.token"
                v-validate="'required'"
                name="shippop_jsonvalue_token"
                data-vv-as="Shippop Token"
              />
              <span class="text-error" v-if="errors.has('shippop_jsonvalue_token')">{{
                errors.first('shippop_jsonvalue_token')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ shippop_jsonvalue.token ? shippop_jsonvalue.token : '-' }}
            </div>
          </div>

          <div class="caption mt-2">Shippop Email</div>
          <div class="form-control" :class="{ 'has-error': errors.has('shippop_jsonvalue_email') }">
            <template v-if="isEdit">
              <input
                type="text"
                v-model="shippop_jsonvalue.email"
                v-validate="'required|email'"
                name="shippop_jsonvalue_email"
                data-vv-as="Shippop Email"
              />
              <span class="text-error" v-if="errors.has('shippop_jsonvalue_email')">{{
                errors.first('shippop_jsonvalue_email')
              }}</span>
            </template>
            <div class="primary--text" v-else>
              {{ shippop_jsonvalue.email ? shippop_jsonvalue.email : '-' }}
            </div>
          </div>

          <div class="text-xs-center" v-if="isEdit">
            <v-btn color="grey" outline @click="onCancel" v-if="showCancel">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn color="primary" depressed @click="onSave">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: {
    ToggleButton
  },
  data() {
    return {
      step: 1,
      shippop_jsonvalue: {
        email: null,
        token: null
      },
      shippop_status: false,
      isEdit: false,
      loading: true,
      showCancel: true
    }
  },
  async mounted() {
    this.loading = true
    var response = await this.getshippop()
    if (response.data && response.data.length > 0) {
      try {
        this.shippop_status = response.data[0].shippop_status
        if (response.data[0].shippop_jsonvalue)
          this.shippop_jsonvalue = JSON.parse(response.data[0].shippop_jsonvalue)
      } catch (error) {}
    }
    if (
      (this.shippop_jsonvalue && this.shippop_jsonvalue.token == null) ||
      !this.shippop_jsonvalue
    ) {
      this.editShippop()
      this.showCancel = false
    } else {
      this.step = 2
    }
    this.loading = false
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  methods: {
    editShippop() {
      this.isEdit = true
      this.cached_shippop_jsonvalue = JSON.stringify(this.shippop_jsonvalue)
      this.cached_shippop_status = this.shippop_status
    },
    onCancel() {
      this.isEdit = false
      this.shippop_jsonvalue = JSON.parse(this.cached_shippop_jsonvalue)
      this.shippop_status = this.cached_shippop_status
    },
    getshippop() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getshippop({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async toggleStatus() {
      var vm = this
      const status = !vm.shippop_status
      try {
        await vm.saveShippop({
          params: {
            pageid: vm.selectedBot.pageid
          },
          body: {
            shippop_status: status,
            shippop_jsonvalue: JSON.stringify(vm.shippop_jsonvalue)
          }
        })
        await this.$store.dispatch('updateBotDetail')
        vm.shippop_status = status
      } catch (error) {
        console.log(error)
      }
    },
    async saveShippop(data) {
      return new Promise((resolve, reject) => {
        api.saveshippop(data, (error, response) => {
          if (error) {
            reject(error)
          }

          resolve(response)
        })
      })
    },
    async onSave() {
      try {
        if (
          this.shippop_jsonvalue.token != null &&
          this.shippop_jsonvalue.email != null &&
          this.shippop_status == null
        )
          this.shippop_status = true
        var result = await this.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        await this.saveShippop({
          params: {
            pageid: this.selectedBot.pageid
          },
          body: {
            shippop_status: this.shippop_status,
            shippop_jsonvalue: JSON.stringify(this.shippop_jsonvalue)
          }
        })
        await this.$store.dispatch('updateBotDetail')

        await this.$swal.fire({
          title: this.$t('Successfully'),
          type: 'success'
        })

        this.cached_shippop_jsonvalue = JSON.stringify(this.shippop_jsonvalue)
        this.cached_shippop_status = this.shippop_status

        this.isEdit = false
        this.showCancel = true
      } catch (error) {}
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShippopManage.vue